export const getServiceWithInstanceCountTemplate = {
  variable: ['$duration: Duration!', '$serviceReq:ServiceReq!','$properties: [KeyValuePair]', '$permissions: [String]'],
  query: `services: getServiceWithInstanceCount(duration: $duration, serviceReq:$serviceReq,properties: $properties,permissions: $permissions) {
    key: id
    label: name
    count: instancesCount
    permissions
  }`
};

export const getServiceInstancesByMetaPropertiesTemplate = {
  variable: ['$duration: Duration', '$serviceId: ID!', '$properties: [KeyValuePair!]!'],
  query: `instanceId: getServiceInstancesByMetaProperties(duration: $duration,serviceId: $serviceId, properties: $properties) {     
    key: id
    label: name
    metaProperty1
    metaProperty2
    metaProperty3
    attributes {
      name
      value
    }
}`
}

export const getMQMetricsCardPropertiesTemplate = {
  variable: ['$condition: MetricsCondition!', '$duration: Duration!', '$metricList: [String]!'],
  query: `values: readMetricsValueList(condition: $condition,duration: $duration,metricList: $metricList) {     
    label
    value
}`
}

export const readAllMetricsFilteredAtServiceScopeTemplate = {
  variable: ['$condition: MetricsCondition!','$duration: Duration!','$valueColumn: String','$properties: [KeyValuePair!]!','$entityIds: [String!]!'],
  query: `readAllMetricsFilteredAtServiceScope: readAllMetricsFilteredAtServiceScope(
    condition: $condition,
    duration: $duration, valueColumn: $valueColumn, properties: $properties, entityIds: $entityIds) {
    label
    values {
      values {id value}
    }
    avg 
    max
    total
    perMin
}`
}

export const getParticipantInstancesByMetaPropertiesTemplate = {
  variable: ['$duration: Duration', '$serviceId: ID!', '$properties: [KeyValuePair!]!'],
  query: `instanceId: getServiceInstancesByMetaProperties(duration: $duration,serviceId: $serviceId, properties: $properties) {     
    key: id
    label: name
    metaProperty2
    attributes {
      name
      value
    }
}`
}

export const getAlertServiceInstancesByMetaPropertiesTemplate = {
  variable: ['$serviceId: ID!', '$properties: [KeyValuePair!]!','$keyword: String', '$limit: Int'],
  query: `instanceId: getServiceInstancesByMetaProperties(serviceId: $serviceId, properties: $properties, keyword: $keyword, limit: $limit) {     
    key: id
    label: name
    metaProperty1
    attributes {
      name
      value
    }
}`
}

export const getKafkaMetricsCardPropertiesTemplate = {
  variable: ['$condition: MetricsCondition!', '$duration: Duration!', '$metricList: [String]!'],
  query: `values: readMetricsValueCards(condition: $condition,duration: $duration,metricList: $metricList) {     
    label
    value
}`
}
